/* eslint-disable */
import {
  axios,
  config
} from '../api'
import store from '../store'

let notice = {}

notice.setState = (_ID,_state) => {
  return axios('post', config.API_URL + '/api/Notice/SetState',{}, {
    ID: _ID,
    state: _state,
  })
}

notice.getList = {
  data: {
    PageIndex: 1,
    PageSize: 10,
    CondList: [
      {
        Key: "",
        Operator: "",
        Value: ""
      }
    ]
  },
  post(_data) {
    _data = _data ? _data : this.data
    return axios('post', config.API_URL + '/api/Notice/GetList', _data)
  }
}

// 删除
notice.del = (_idList) => {
  return axios('post', config.API_URL + '/api/Notice/Del',{}, {
    idList: _idList
  })
}

export default notice



